/* tslint:disable */
/* eslint-disable */
/**
 * Prove Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetHistories200ResponseHistoriesInnerGps
 */
export interface GetHistories200ResponseHistoriesInnerGps {
    /**
     * 緯度
     * @type {number}
     * @memberof GetHistories200ResponseHistoriesInnerGps
     */
    lat?: number;
    /**
     * 経度
     * @type {number}
     * @memberof GetHistories200ResponseHistoriesInnerGps
     */
    lon?: number;
}

/**
 * Check if a given object implements the GetHistories200ResponseHistoriesInnerGps interface.
 */
export function instanceOfGetHistories200ResponseHistoriesInnerGps(value: object): value is GetHistories200ResponseHistoriesInnerGps {
    return true;
}

export function GetHistories200ResponseHistoriesInnerGpsFromJSON(json: any): GetHistories200ResponseHistoriesInnerGps {
    return GetHistories200ResponseHistoriesInnerGpsFromJSONTyped(json, false);
}

export function GetHistories200ResponseHistoriesInnerGpsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistories200ResponseHistoriesInnerGps {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
    };
}

export function GetHistories200ResponseHistoriesInnerGpsToJSON(json: any): GetHistories200ResponseHistoriesInnerGps {
    return GetHistories200ResponseHistoriesInnerGpsToJSONTyped(json, false);
}

export function GetHistories200ResponseHistoriesInnerGpsToJSONTyped(value?: GetHistories200ResponseHistoriesInnerGps | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lon': value['lon'],
    };
}

